import { get, post, put } from "../Config";

//POST
export function CreateBooking({ data }) {
  return post({ url: `/api/sb/v1/createBooking`,data});
}
